<template>
  <CRow>

    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-money" />
          <h5 class="d-inline ml-2">Voucher List</h5>
          <div class="card-header-actions">
            <CButton color="primary" :to="{ name: 'Add New Voucher'}">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add New</strong> Voucher
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Vouchers",
  components: {
    BackendTable,
  },
};
</script>
